import type { ToiletPhotoKind } from "./types";

export const REPORT_PHOTO_MAX_BYTES = 5 * 1024 * 1024;
export const REPORT_PHOTO_ACCEPT = "image/jpeg,image/png,image/webp";

const allowedPhotoTypes = new Set(REPORT_PHOTO_ACCEPT.split(","));

export const photoKindLabel: Record<ToiletPhotoKind, string> = {
  location: "場所・入口",
  exterior: "外観",
};

export function validateReportPhoto(file: File): string | undefined {
  if (!allowedPhotoTypes.has(file.type.toLowerCase())) {
    return "JPEG、PNG、WebP形式の写真を選んでください。";
  }
  if (file.size === 0) return "空の写真ファイルは投稿できません。";
  if (file.size > REPORT_PHOTO_MAX_BYTES) {
    return "写真は5MB以下にしてください。";
  }
  return undefined;
}
